var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"font16",staticStyle:{"color":"red"}},[_vm._v("Dear customer, the keypad cannot be selected because is a phased out.")]),_c('p',[_vm._v("Please contact our sales team to find the best solution.")])])
}]

export { render, staticRenderFns }